import { GoogleDriveResource } from "~/classes/models/education-resources/education-resource.model";
import { usePickGoogleDriveFile } from "~/composables/usePickGoogleDriveFile";

type GoogleDriveDestinationContext = {
  folder: GoogleDriveResource;
  accessToken: string;
  createFileInFolder: (
    folderId: string,
    fileMetadata: {
      name: string;
      mimeType: string;
      content?: string | Blob;
    }
  ) => Promise<any>;
  createFolderInFolder: (folderId: string, folderName: string) => Promise<any>;
};

type PickGoogleDriveDestinationParams = {
  onDestinationPicked: (
    context: GoogleDriveDestinationContext
  ) => Promise<void> | void;
  onCancel?: () => Promise<void> | void;
  onError?: (error: unknown) => Promise<void> | void;
};

export const usePickGoogleDriveDestination = () => {
  const pickGoogleDriveDestination = async ({
    onDestinationPicked,
    onCancel,
    onError,
  }: PickGoogleDriveDestinationParams) => {
    const { pickGoogleDriveFile, createFileInFolder, createFolderInFolder } =
      usePickGoogleDriveFile({
        supportedMimeTypes: ["documents"],
        returnFile: false,
        folderSelect: true,
        onFilePicked: async (folder: GoogleDriveResource, accessToken: string) => {
          if (!folder || !accessToken) {
            await onCancel?.();
            return;
          }

          try {
            await onDestinationPicked({
              folder,
              accessToken,
              createFileInFolder,
              createFolderInFolder,
            });
          } catch (error) {
            console.error(error);
            await onError?.(error);
          }
        },
      });

    await pickGoogleDriveFile();
  };

  return {
    pickGoogleDriveDestination,
  };
};
